export const shareDocumentButtonPopoverTestIds = {
  shareButton: 'share-document-button',
  menu: 'share-document-menu',
};
